  <template>
    <div class="labels-settings">
      <v-form ref="labelsForm" v-model="formValid">
        <!-- Success Alert -->
          <!-- <div class="custom-alert-snackbar">
            <v-alert
              v-model="successAlert.show"
              type="success"
              dismissible
              elevation="2"
              border="left"
              transition="scroll-y-transition"
              class="mb-4"
            >
              <span v-html="successAlert.message"></span>
            </v-alert>

          </div> -->

        <!-- Error Alert -->
        <!-- <v-alert
          v-model="errorAlert.show"
          type="error"
          dismissible
          elevation="2"
          border="left"
          transition="scroll-y-transition"
          class="mb-4"
        >
          <span v-html="errorAlert.message"></span>
        </v-alert> -->

        <!-- Labels Section -->
        <v-card class="mb-6">
          <v-card-title class="d-flex align-center">
            <v-icon class="mr-2">mdi-label</v-icon>
            <span class="headline">LABELS SETTINGS</span>
          </v-card-title>
          <v-card-text>
            <v-row class="mb-2">
              <v-col class="pt-1 my-auto" md="3" sm="12">
                <label class="font-size-16 font-weight-500">Service Label</label>
              </v-col>
              <v-col class="pt-1" md="9" sm="12">
                <v-text-field
                  v-model="labelsSettings.serviceLabel"
                  dense
                  filled
                  placeholder="Enter Service Label"
                  solo
                  flat
                  color="cyan"
                  :rules="[rules.required]"
                  @input="onLabelsChanged"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row class="mb-2">
              <v-col class="pt-1 my-auto" md="3" sm="12">
                <label class="font-size-16 font-weight-500">About Us Label</label>
              </v-col>
              <v-col class="pt-1" md="9" sm="12">
                <v-text-field
                  v-model="labelsSettings.aboutUsLabel"
                  dense
                  filled
                  placeholder="Enter About Us Label"
                  solo
                  flat
                  color="cyan"
                  :rules="[rules.required]"
                  @input="onLabelsChanged"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row class="mb-2">
              <v-col class="pt-1 my-auto" md="3" sm="12">
                <label class="font-size-16 font-weight-500">Payment Label</label>
              </v-col>
              <v-col class="pt-1" md="9" sm="12">
                <v-text-field
                  v-model="labelsSettings.paymentLabel"
                  dense
                  filled
                  placeholder="Enter Payment Label"
                  solo
                  flat
                  color="cyan"
                  :rules="[rules.required]"
                  @input="onLabelsChanged"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row class="mb-2">
              <v-col class="pt-1 my-auto" md="3" sm="12">
                <label class="font-size-16 font-weight-500">Booking Details Label</label>
              </v-col>
              <v-col class="pt-1" md="9" sm="12">
                <v-text-field
                  v-model="labelsSettings.bookingDetailsLabel"
                  dense
                  filled
                  placeholder="Enter Booking Details Label"
                  solo
                  flat
                  color="cyan"
                  :rules="[rules.required]"
                  @input="onLabelsChanged"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <!-- Save Button -->
        <div class="d-flex justify-end">
          <v-btn
            color="success"
            :loading="saving"
            @click="saveSettings"
            :disabled="!formValid"
          >
            <v-icon left>mdi-content-save</v-icon>
            {{ isEditing ? 'Update Changes' : 'Save Changes' }}
          </v-btn>
        </div>
      </v-form>
    </div>
  </template>

  <script>
  export default {
    name: "Labels",
    props: {
      initialLabelsSettings: {
        type: Object,
        default: () => ({})
      },
      saving: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        formValid: false,
        isEditing: false,
        
        labelsSettings: {
          serviceLabel: 'Services',
          aboutUsLabel: 'About Us',
          paymentLabel: 'Payment',
          bookingDetailsLabel: 'Booking Details',
          ...this.initialLabelsSettings
        },

        rules: {
          required: value => !!value || 'This field is required.'
        }
      }
    },

    watch: {
      initialLabelsSettings: {
        handler(newVal) {
          this.labelsSettings = { ...this.labelsSettings, ...newVal };
          this.isEditing = Object.keys(newVal).length > 0;
        },
        deep: true,
        immediate: true
      }
    },

    mounted() {
      this.loadLabelsSettings();
      
      // Listen for success/error events from parent
      this.$parent.$on('labels-success', this.showSuccess);
      this.$parent.$on('labels-error', this.showError);
    },

    beforeDestroy() {
      // Clean up event listeners
      this.$parent.$off('labels-success', this.showSuccess);
      this.$parent.$off('labels-error', this.showError);
    },

    methods: {
      async loadLabelsSettings() {
        try {
          const response = await this.$http.get('/web-setup/labels');
          if (response.data.success && response.data.data) {
            this.labelsSettings = { ...this.labelsSettings, ...response.data.data };
            this.isEditing = true;
          }
        } catch (error) {
          console.error('Error loading labels settings:', error);
          this.showError('Failed to load labels settings');
        }
      },

      async saveSettings() {
        if (!this.formValid) return;

        const settingsData = {
          ...this.labelsSettings
        };

        // Emit to parent component (WebSetup.vue) to handle the actual saving
        this.$emit('save-labels', settingsData);
      },

      getLabelsData() {
        return {
          ...this.labelsSettings
        };
      },

      onLabelsChanged() {
        this.$emit('labels-changed');
      },
      showSuccess(message) {
          this.$emit('labels-success', message); 
      },
      showError(message) {
      this.$emit('labels-error', message); 
      },
    }
  }
  </script>

  <style lang="scss" scoped>
  .labels-settings {
    padding: 20px;
  }
  </style>